import React, { FC, useCallback } from "react";

import { faLink } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";

import Resource from "@mapmycustomers/shared/types/entity/Resource";
import { fileTypeToIcons, getFileType } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import useAnalytics from "@app/util/contexts/useAnalytics";

import ActionsButton from "../ActionsButton";
import ResourceInfo from "../ResourceInfo";

import styles from "./ResourceCard.module.scss";

export interface ResourceCardProps {
  resource: Resource;
}

const ResourceCard: FC<ResourceCardProps> = ({ resource }) => {
  const history = useHistory();
  const analytics = useAnalytics();

  const handleFileClick = useCallback(() => {
    analytics.clicked(["Resource Tile"]);
    if (resource.file?.id) {
      history.push(`${Path.RESOURCES}/files/${resource.id}`);
    } else if (resource.url) {
      window.open(resource.url, "_blank");
    }
  }, [analytics, resource.file?.id, resource.url, resource.id, history]);

  return (
    <div className={styles.container} onClick={handleFileClick}>
      <div className={styles.left}>
        <div className={styles.fileType}>
          <FontAwesomeIcon
            className={styles.fileIcon}
            icon={resource.file ? fileTypeToIcons[getFileType(resource.file)].solid : faLink}
          />
        </div>
        <ResourceInfo resource={resource} />
      </div>
      <ActionsButton isPinned resource={resource} size="middle" />
    </div>
  );
};

export default ResourceCard;
